import { queryHtmlElement } from "../core/dom";

/**
 * Moves focus to the server-rendered billing notice or trial quote heading.
 *
 * Both are rendered after a form submission redirect, so keyboard and screen
 * reader users need focus moved to the new copy. This stays independent of the
 * interactive map so the notice still receives focus when that chunk fails.
 */
export class BillingFocusController {
  private readonly notice: HTMLElement | null;
  private readonly trialQuoteTitle: HTMLElement | null;

  public constructor(root: HTMLElement) {
    this.notice = queryHtmlElement(root, "[data-billing-notice]", HTMLElement);
    this.trialQuoteTitle = queryHtmlElement(root, "[data-billing-trial-quote-title]", HTMLElement);
  }

  public connect(): void {
    if (this.notice !== null) {
      this.notice.focus();
      return;
    }
    this.trialQuoteTitle?.focus();
  }
}
